import { render, staticRenderFns } from "./Swelling.vue?vue&type=template&id=7e7737bf"
import script from "./Swelling.vue?vue&type=script&lang=js"
export * from "./Swelling.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports